import { z } from 'zod';

export const ConfirmSpamRequestSchema = z
  .object({
    reason: z.string().trim().min(10).max(500),
  })
  .strict();

export type ConfirmSpamRequest = z.infer<typeof ConfirmSpamRequestSchema>;
